(ns re-graph.logging
  (:refer-clojure :exclude [time])
  (:require [goog.log :as glog]))

(def logger
  (glog/getLogger "app"))

;; `re-graph` 0.1.11 references `goog.debug.Logger.Level.*` directly at load
;; time, which breaks in our optimized bundle. We only need lightweight logging
;; behavior here, so keep the public API and avoid hard dependency on those
;; nested Closure constants.
(defn log-to-console! []
  nil)

(defn set-level! [_level]
  nil)

(defn fmt [msgs]
  (apply str (interpose " " (map pr-str msgs))))

(defn info [& s]
  (glog/info logger (fmt s)))

(defn debug [& s]
  (glog/fine logger (fmt s)))

(defn warn [& s]
  (glog/warning logger (fmt s)))

(defn error [& s]
  (glog/error logger (fmt s)))
